module.exports = __webpack_public_path__ + "static/media/logo-jira-symbol.70365e83.svg";